module.exports = __webpack_public_path__ + "img/IMG_0374_L_Wood.7023913f.jpg";